import toString from 'lodash/toString';
var minLength = function minLength(_a) {
  var _b = _a === void 0 ? {
      message: 'Обязательное поле',
      limit: 0
    } : _a,
    limit = _b.limit,
    message = _b.message;
  return function (value) {
    if (!value || toString(value).length < limit) {
      return message;
    }
    return;
  };
};
export default minLength;
export { minLength };